import React from "react";

export default function Diaplay(props) {
  return (
    <input
      type="text"
      value={props.value}
      className="display"
      onChange={() => null}
    />
  );
}
